/**
 * Component for handling images and rerenders upon errors
 *
 * @module components/ImageLoader/Image
 */

import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import * as Actions from '../../actions';
import { AppContext } from '../../lib/Context';
import * as Utils from '../../utils';

export class Img extends React.Component {
  static propTypes = {
    src: PropTypes.string.isRequired,
    replacementImg: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    classes: PropTypes.string,
    qaTag: PropTypes.string,
    alt: PropTypes.string,
    styles: PropTypes.object,
    onLoadFunc: PropTypes.func,
    role: PropTypes.string,
    onImgErrored: PropTypes.func.isRequired,
  };

  static defaultProps = {
    replacementImg: Utils.Art.getDefaultArt(),
  };

  state = {
    src: this.props.src || this.props.replacementImg,
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.src !== this.props.src) {
      this.setState({
        src: nextProps.src,
      });
    }
  }

  static contextType = AppContext;

  onImgError = () => {
    const failingSrc = this.state.src;
    this.setState({
      src: this.props.replacementImg,
    });

    const data = this.context.integration.getActionData();
    this.props.onImgErrored({
      asset_url: failingSrc,
      ...data,
    });
  };

  render() {
    if (Utils.Url.isValidImgUrl(this.state.src)) {
      return (
        <img
          src={this.state.src}
          onError={this.onImgError}
          data-qa={this.props.qaTag}
          style={this.props.styles}
          role={this.props.role}
          alt={this.props.alt}
          onLoad={this.props.onLoadFunc}
          className={this.props.classes}
        />
      );
    }
    return null;
  }
}

const mapDispatchToProps = {
  onImgErrored: Actions.Integrations.imageFetchErrored,
};

export default connect(null, mapDispatchToProps)(Img);
